import React from "react";
import { User, ApplicationSubscription } from "../services/workspaceAPI";
import { createCtx } from "./ContextHelper";
import { dmnStorage } from "../utils/dmnStorage";

interface UserContextProps {
  children: React.ReactNode;
}

interface UserContextType {
  user?: User;
  users: User[];
  setUsers: (users: User[]) => void;
  subscriptionId: string;
  setSubscriptionId: (subscriptionId: string) => void;
  getSubscription: () => ApplicationSubscription | undefined;
}

export const [useUserContext, CtxProvider] = createCtx<UserContextType>();

export const UserContextProvider = ({ children }: UserContextProps) => {
  const [users, setUsers] = React.useState<User[]>([]);
  const [subscriptionId, storeSubscriptionId] = React.useState<string>("");

  const user =
    users.find(
      (u) =>
        u.applicationUsers?.find(
          (au) => au?.applicationSubscription?.id === subscriptionId
        ) !== undefined
    ) ?? users[0];

  const getSubscription = () => {
    if (!user) return undefined;
    if (!user.applicationUsers) return undefined;

    const applicationUser = user.applicationUsers.find(
      (au) => au?.applicationSubscription?.id === subscriptionId
    );

    return applicationUser
      ? (applicationUser.applicationSubscription as ApplicationSubscription)
      : undefined;
  };

  const setSubscriptionId = (newSubscriptionId: string) => {
    storeSubscriptionId(newSubscriptionId);
    dmnStorage.add("SubscriptionId", newSubscriptionId);
  };

  return (
    <CtxProvider
      value={{
        user,
        users,
        setUsers,
        subscriptionId,
        setSubscriptionId,
        getSubscription
      }}
    >
      {children}
    </CtxProvider>
  );
};
